module.exports = __webpack_public_path__ + "static/media/index-icon-bookmark.62477e29.svg";